import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/questionnaire-templates/field-templates/{fieldTemplateId}/pdf-fills']['GET'];
type Input = ThisApi['params'] & ThisApi['query'];

const getPdfFillsForFieldTemplate = async ({
  fieldTemplateId,
  listFieldTemplateId,
}: Input): Promise<ThisApi['response']> => {
  const data = await formsBackendClient.get(`/questionnaire-templates/field-templates/${fieldTemplateId}/pdf-fills`, {
    params: { listFieldTemplateId },
  });
  return data.data;
};

export default getPdfFillsForFieldTemplate;
